// extracted by mini-css-extract-plugin
export default {"master":"master-module--master--81542","wFull":"master-module--w-full--90ea4"};